import React, { Children } from 'react';
import { DropdownItem } from './dropdown-item';
const MAX_DEPTH = 5;
export const getCurrentValueFromChildrenInternal = (value, children, deepSearch = true, maxDepth = MAX_DEPTH, currentDepth = 0) => {
  let returnValue = value;
  if (!children) {
    return returnValue;
  }
  Children.forEach(children, child => {
    var _child$props, _child$props2;
    if (! /*#__PURE__*/React.isValidElement(child) || returnValue !== value) {
      return;
    }
    if (child.type !== DropdownItem) {
      if (child.props.children && currentDepth + 1 < maxDepth) {
        returnValue = getCurrentValueFromChildrenInternal(value, child.props.children, deepSearch, maxDepth, currentDepth + 1);
      }
      return;
    }
    const childValue = (_child$props = child.props) == null ? void 0 : _child$props.value;
    const childText = (_child$props2 = child.props) == null ? void 0 : _child$props2.text;
    if (childValue === value) {
      returnValue = childText;
    }
  });
  return returnValue;
};
export const getCurrentValueFromChildren = (value, children) => getCurrentValueFromChildrenInternal(value, children);